var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.warningZone)?_c('div',[_c('h3',{staticClass:"red"},[_vm._v("Bij inactiviteit wordt u automatisch uitgelogd!")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }